import React, {useState} from 'react';
import Select, { components }  from 'react-select';
import { default as t } from '../../../utils/i18n';
import { AppTooltip } from '..';

import './checkpicker.scss';
import { CheckPicker } from 'rsuite';
const CaretDownIcon = () => {
  return <i className='eva eva-arrow-down'></i>;
};

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};


const createGroup = (groupName, options, setValue) => {
  return {
    label: (() => {
      return (
        <div className='cat-label'
          onClick={() =>
            setValue(value =>
              value.concat(options.filter(grpOpt => !value.includes(grpOpt)))
            )
          }
        >
          {groupName}
        </div>
      );
    })(),
    options: options
  };
};



const Checkpicker = ({ heading, options, isLoading, value, onSelect, placeholder,customIndicator = false, tooltipIndicator = false, searchIndicator=false, isMultiCategory = false,
   tooltipId = '', infoData = '', isImportant = false}) => {
    const [values, setValue] = useState([]);
    let option;
    if(isMultiCategory) {
      option = []
      options?.forEach(opt => {
        option.push(createGroup(opt?.name, opt?.groupOptions, setValue))
      })
    }
  return (
    <div className='c-dropdown'>
      <div className={tooltipIndicator ? "header" : 'c-dropdown'}>
          <h3 className='c-text-heading-3'>{heading}{isImportant ? <span className='imp-icon'>*</span>: ''}</h3>
        {tooltipIndicator ? 
        <span>
          <i className="eva eva-info-outline" data-tip={infoData} data-for={tooltipId}></i>
          <AppTooltip className="c-table-info-icon--tooltip" id={tooltipId} place='right'/>
        </span> : null}
      </div>

      <CheckPicker className='check-picker'
        disabled={false}
        loading={isLoading}
        components={customIndicator ? { DropdownIndicator } : null}
        placeholder={placeholder ?? t('dropdown.text.default')}
        data={options}
        value={value}
        onChange={onSelect}
        styles={{
          dropdownIndicator: (provided, state) => ({
            ...provided,
            transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
          })
        }}
      />
    </div>
  );
};

export default Checkpicker;
